const CROSSCHAINADDR = {
  devnet: {
    // USDT: "0x1D54EcB8583Ca25895c512A8308389fFD581F9c9",
    cusd: "0xd8fc74a40aa21d506ae3b9326697290990dce76a",
    FX: "0x5FD55A1B9FC24967C4dB09C513C3BA0DFa7FF687",
  },
  devtest: {
    // USDT: "0x1D54EcB8583Ca25895c512A8308389fFD581F9c9",
    cusd: "0xd8fc74a40aa21d506ae3b9326697290990dce76a",
    FX: "0x5FD55A1B9FC24967C4dB09C513C3BA0DFa7FF687",
  },
  testnet: {
    // USDT: "0x3515F25AB7637adcF1b69F4D384ed5936B83431F",
    cusd: "0xd8fc74a40aa21d506ae3b9326697290990dce76a",
    FX: "0x3452e23F9c4cC62c70B7ADAd699B264AF3549C19",
  },
  mainnet: {
    // USDT: "0xecEEEfCEE421D8062EF8d6b4D814efe4dc898265",
    cusd: "0xd8fc74a40aa21d506ae3b9326697290990dce76a",
    FX: "0x80b5a32E4F032B2a058b4F29EC95EEfEEB87aDcd",
  },
};

const WITHDRAWREWARDS = {
  devnet: {
    FX: "",
  },
  devtest: {
    FX: "0x8E802f7BA7e3e20bE025a2049E4509aa7cd78d64",
  },
  testnet: {
    FX: "0xe600F62e0F9Ec6b827E768D3F25C2fe1BB88Cf28",
  },
  mainnet: {
    FX: "0xAA4D3a1703F898bB4432224CE4e09688b6EBD4AA",
  },
};

const FXEVM = {
  // FX EVM devnet
  devnet: {
    chainId: 221,
    rpc: "http://3.210.229.34:8545",
    chainName: "fxcore-evm(devnet)",
    nativeCurrency: {
      name: "FX",
      symbol: "FX",
      decimals: 18,
    },
  },
  // FX EVM devtest
  devtest: {
    chainId: 530,
    rpc: "https://test-fxcore-evm.marginx.io/",
    chainName: "fxcore-evm(devtest)",
    nativeCurrency: {
      name: "FX",
      symbol: "FX",
      decimals: 18,
    },
  },
  // FX EVM testnet
  testnet: {
    chainId: 90001,
    rpc: "https://testnet-fx-json-web3.functionx.io:8545",
    chainName: "fxcore-evm(testnet)",
    nativeCurrency: {
      name: "FX",
      symbol: "FX",
      decimals: 18,
    },
  },
  // FX EVM mainnet
  mainnet: {
    chainId: 530,
    rpc: "https://fx-json-web3.functionx.io:8545",
    chainName: "fxcore-evm",
    nativeCurrency: {
      name: "FX",
      symbol: "FX",
      decimals: 18,
    },
  },
};

const MARGINX = {
  // MARGINX devnet
  devnet: {
    chainId: "marginx_100-1",
    evmChainId: 100,
    jsonRpcUrl: "http://18.235.16.141:26657",
    web3Url: "http://18.235.16.141:8545",
    restUrl: "http://18.235.16.141:1317",
    chainName: "MarginX(Devnet)",
    stepIntoChannel: "channel-108",
    stepOutChannel: "channel-0",
  },
  // MARGINX devtest
  devtest: {
    chainId: "MarginX-Devtest-Multi",
    evmChainId: 1963,
    jsonRpcUrl: "https://testnet-multi-json.marginx.io:26657",
    web3Url: "https://testnet-multi-web3.marginx.io:8545",
    restUrl: "https://testnet-multi-rest.marginx.io:1317",
    chainName: "MarginX(Devtest)",
    stepIntoChannel: "channel-108",
    stepOutChannel: "channel-0",
  },
  // MARGINX testnet
  testnet: {
    chainId: "marginx_10-1",
    evmChainId: 10,
    jsonRpcUrl: "https://testnet-multi-json.marginx.io:26657",
    web3Url: "https://testnet-multi-web3.marginx.io:8545",
    restUrl: "https://testnet-multi-rest.marginx.io:1317",
    chainName: "MarginX(Testnet)",
    stepIntoChannel: "channel-112",
    stepOutChannel: "channel-0",
  },
  // MARGINX mainnet
  mainnet: {
    chainId: "MarginX-Multi",
    evmChainId: 1963,
    jsonRpcUrl: "https://testnet-multi-json.marginx.io:26657",
    web3Url: "https://testnet-multi-web3.marginx.io:8545",
    restUrl: "https://testnet-multi-rest.marginx.io:1317",
    chainName: "MarginX",
    stepIntoChannel: "channel-108",
    stepOutChannel: "channel-0",
  },
};

export default {
  CrossChainAddr: CROSSCHAINADDR[process.env.VUE_APP_ENV],
  WithdrawRewardsAddr: WITHDRAWREWARDS[process.env.VUE_APP_ENV],
  FxEvm: FXEVM[process.env.VUE_APP_ENV],
  Marginx: MARGINX[process.env.VUE_APP_ENV],
};
